module.exports = __webpack_public_path__ + "static/img/慰问一线基层员工并转达亲切问候.3fe6441c.jpg";